import { defaultHttpClient } from '../../httpClient';

export interface Coupon {
  sno: number;
  coupon_type: string;
  name: string;
  title: string;
  display_title: string;
  description: string;
  discount_type: string;
  discount_percent: number | null;
  discount_price: number | null;
  conditions: string;
  conditions_with_markup: string;
  is_issued: boolean;
  is_enabled: boolean;
  is_partial_refundable: boolean;
  extension: {
    type: string;
  };
  issuer_type: string | null;
  is_stackable: boolean | null;
  applicable_type: number;
  started_at: string | null;
  finished_at: string | null;
  expiration_days: number | null;
}

export interface CouponCtaInfo {
  cta_description: string;
}

export interface GoodsCouponResponse {
  coupon: Coupon | null;
  is_exist_usable_coupons: boolean;
  coupon_cta_info: CouponCtaInfo | null;
}

export const getGoodsCoupon = (goodsSno: number) => {
  return defaultHttpClient
    .request<GoodsCouponResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/coupon/`,
    })
    .then(result => result.data);
};
